import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  couponActivityAdd (params) { // 新增抢券
    return axios.post(global.MMC_CAMPAIGN + '/coupon/insertCouponCampaign', params)
  },
  couponActivityDetail (params) { // 抢券活动详情
    return axios.post(global.MMC_CAMPAIGN + '/coupon/findCampaignDetails', params)
  },
  couponActivityEdit (params) { // 抢券活动修改
    return axios.post(global.MMC_CAMPAIGN + '/coupon/updateCouponCampaign', params)
  },
  couponActivityDelete (params) { // 抢券活动删除
    return axios.post(global.MMC_CAMPAIGN + '/coupon/deleteCouponCampaign', params)
  },
  couponActivityStart (params) { // 抢券活动启用
    return axios.post(global.MMC_CAMPAIGN + '/coupon/startCampaign', params)
  },
  couponActivityStop (params) { // 抢券活动停用
    return axios.post(global.MMC_CAMPAIGN + '/coupon/stopCampaign', params)
  },
  couponDeliverAdd (params) { // 派发优惠券
    return axios.post(global.MMC_CAMPAIGN + '/coupon/insertCouponDeliver', params)
  },
  couponDeliverDetails (params) { // 查看派发详情
    return axios.post(global.MMC_CAMPAIGN + '/coupon/findDeliverDetails', params)
  },
  couponDeliverRuleAdd (params) { // 新增发券规则
    return axios.post(global.MMC_CAMPAIGN + '/coupon/insertCouponRule', params)
  },
  couponDeliverRuleUpdate (params) { // 修改发券规则
    return axios.post(global.MMC_CAMPAIGN + '/coupon/updateCouponRule', params)
  },
  couponDeliverRuleDelete (params) { // 修改发券规则
    return axios.post(global.MMC_CAMPAIGN + '/coupon/deleteCouponRule', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/coupon.js